import { randomDigits, randomWord } from '@ps-gui/shared-utils';

/** Five digits is what `Validations.zip()` accepts - a leading zero is fine. */
export const randomZipCode = () => randomDigits(5);

/** Random parts, but the shape `Validations.email()` accepts. */
export const randomEmailAddress = () =>
  `${randomWord(6, 9)}.${randomWord(8, 13)}@${randomWord(6, 10)}.de`.toLowerCase();

export const addDays = (date: Date, days: number) => {
  const shifted = new Date(date);
  shifted.setDate(shifted.getDate() + days);
  return shifted;
};

/** The format every date field in CT2 is validated against (`Validations.date()`). */
export const formatDate = (date: Date) =>
  [date.getDate(), date.getMonth() + 1]
    .map((part) => String(part).padStart(2, '0'))
    .concat(String(date.getFullYear()))
    .join('.');
